import './lncanada9/style';
import FormStructure from './lncanada9/form_structure';

export default FormStructure;